import pxToRem from "./pxToRem";
import rgba from "./rgba";

function boxShadow(
  offset: [number, number] = [0, 0],
  radius: [number, number] = [0, 0],
  color: string,
  opacity: number,
  inset: string = ""
): string {
  const [x, y] = offset;
  const [blur, spread] = radius;

  return `${inset} ${pxToRem(x)} ${pxToRem(y)} ${pxToRem(blur)} ${pxToRem(spread)} ${rgba(color, opacity)}`;
}

export default boxShadow;
